import {
  clearSettingsFromStorage,
  getSettingsFromStorage,
  saveSettingsToStorage,
} from "@store/minersTable/helpers";
import {
  ActionAddSavedSetting,
  ActionBaseSavedSettings,
  ActionRemoveSavedSetting,
  ActionSetSavedSettings,
  ActionTypesSavedSettingsE,
  ISavedMinerSetting,
} from "./actionTypes";

interface IState {
  savedSettings: ISavedMinerSetting[];
}

const initialState: IState = {
  savedSettings: getSettingsFromStorage(),
};

const reducer = (
  state = initialState,
  action: ActionBaseSavedSettings
): IState => {
  switch (action.type) {
    case ActionTypesSavedSettingsE.SET_SAVED_SETTINGS:
      const { savedSettings } = (action as ActionSetSavedSettings).payload;
      return {
        ...state,
        savedSettings,
      };
    case ActionTypesSavedSettingsE.ADD_SAVED_SETTINGS:
      const { newSavedSetting } = (action as ActionAddSavedSetting).payload;
      const settings = [
        ...state.savedSettings.filter(
          (s) => s.cloned_miner !== newSavedSetting.cloned_miner
        ),
        newSavedSetting,
      ];
      saveSettingsToStorage(settings);
      return {
        ...state,
        savedSettings: settings,
      };
    case ActionTypesSavedSettingsE.REMOVE_SAVED_SETTING:
      const name = (action as ActionRemoveSavedSetting).payload;
      const removedSettings = state.savedSettings.filter(
        (item) => item.cloned_miner !== name
      );
      saveSettingsToStorage(removedSettings);
      return {
        ...state,
        savedSettings: removedSettings,
      };
    case ActionTypesSavedSettingsE.CLEAR_SAVED_SETTINGS:
      clearSettingsFromStorage();
      return {
        ...state,
        savedSettings: [],
      };

    default:
      return { ...state };
  }
};

export default reducer;
